import {
  LAB_QUALITY_EVALUATION_LOCATION,
  LAB_QUALITY_EVALUATION_RAW_MATERIAL,
  LAB_QUALITY_EVALUATION_REQUEST_FORM,
  LAB_QUALITY_EVALUATION_TABLE_LOG,
  LAB_QUALITY_EVALUATION_DETAIL,
  LAB_QUALITY_EVALUATION_CREATE,
  LAB_QUALITY_EVALUATION_DELETE,
  LAB_QUALITY_EVALUATION_CALCULATE,
  LAB_QUALITY_EVALUATION_LOAD_DIVISION,
  LAB_QUALITY_EVALUATION_LOAD_DEPARTMENT,
  LAB_QUALITY_EVALUATION_LOAD_SECTION,
  LAB_QUALITY_EVALUATION_LOAD_PLANT,
  LAB_QUALITY_EVALUATION_LOAD_LOCATION_FORM,
  LAB_QUALITY_EVALUATION_TEST_CENTER,
  LAB_QUALITY_EVALUATION_EDIT,
  LAB_QUALITY_EVALUATION_EXPORT_EXCEL,
  LAB_QUALITY_EVALUATION_GET_USER_CAN_ADD,
  REMOVE_LISTS,
} from './actions'

const initialState = {
  // *load ข้อมูลสถานที่
  source_list: [],
  check_source_list: false,

  // *load ข้อมูลวัตถุดิบ
  material_list: [],
  check_material_list: false,

  // *table log ประเมินคุณภาพ
  check_table_log: false,
  table_log_list: [],
  table_log_total: 0,

  // *request form ประเมินคุณภาพ
  lists_request_form: [],
  check_request_form: false,

  // *detail ประเมินคุณภาพ
  lists_detail: [],
  check_detail: false,

  // *create form ประเมินคุณภาพ
  check_create: false,
  create_response: null,

  // *delete form
  check_delete: false,
  delete_response: null,

  // *calculate form
  check_calculate: false,
  lists_calculate: [],

  // *loadข้อมูลสำหรับ filter
  division_list: [],
  check_division_list: false,

  department_list: [],
  check_department_list: false,

  section_list: [],
  check_section_list: false,

  plant_list: [],
  check_plant_list: false,

  // *load ข้อมูลต้นทาง-โรงงาน สำหรับ modal ฟอร์มประเมิน
  form_location_list: [],
  check_load_location_form: false,

  test_center_list: [],
  check_test_center_list: false,

  // *edit form ประเมินคุณภาพ
  check_edit: false,
  edit_response: null,

  // *export excel
  lab_quality_export_excel: {},
  check_lab_quality_export_excel: false,

  // *get user can add
  user_can_add: [],
  check_user_can_add: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState
    case LAB_QUALITY_EVALUATION_LOCATION.REQUEST:
      return {
        ...state,
        source_list: [],
        check_source_list: true,
      }
    case LAB_QUALITY_EVALUATION_LOCATION.SUCCESS:
      return {
        ...state,
        source_list: action.payload.lists || [],
        check_source_list: false,
      }

    case LAB_QUALITY_EVALUATION_RAW_MATERIAL.REQUEST:
      return {
        ...state,
        material_list: [],
        check_material_list: true,
      }
    case LAB_QUALITY_EVALUATION_RAW_MATERIAL.SUCCESS:
      return {
        ...state,
        material_list: action.payload.lists || [],
        check_material_list: false,
      }

    case LAB_QUALITY_EVALUATION_TABLE_LOG.REQUEST:
      return {
        ...state,
        check_table_log: true,
      }
    case LAB_QUALITY_EVALUATION_TABLE_LOG.SUCCESS:
      return {
        ...state,
        check_table_log: false,
        table_log_list: action.payload.lists.data || [],
        table_log_total: action.payload.lists.total || 0,
      }

    case LAB_QUALITY_EVALUATION_REQUEST_FORM.REQUEST:
      return {
        ...state,
        lists_request_form: [],
        check_request_form: true,
      }
    case LAB_QUALITY_EVALUATION_REQUEST_FORM.SUCCESS:
      return {
        ...state,
        lists_request_form: action.payload.lists,
        check_request_form: false,
      }

    case LAB_QUALITY_EVALUATION_DETAIL.REQUEST:
      return {
        ...state,
        lists_detail: [],
        check_detail: true,
      }
    case LAB_QUALITY_EVALUATION_DETAIL.SUCCESS:
      return {
        ...state,
        lists_detail: action.payload.lists,
        check_detail: false,
      }

    case LAB_QUALITY_EVALUATION_CREATE.REQUEST:
      return {
        ...state,
        check_create: true,
        create_response: null,
      }
    case LAB_QUALITY_EVALUATION_CREATE.SUCCESS:
      return {
        ...state,
        check_create: false,
        create_response: action.payload.lists,
      }

    case LAB_QUALITY_EVALUATION_DELETE.REQUEST:
      return {
        ...state,
        check_delete: true,
        delete_response: null,
      }
    case LAB_QUALITY_EVALUATION_DELETE.SUCCESS:
      return {
        ...state,
        check_delete: false,
        delete_response: action.payload.lists,
      }
    case LAB_QUALITY_EVALUATION_CALCULATE.REQUEST:
      return {
        ...state,
        lists_calculate: [],
        check_calculate: true,
      }
    case LAB_QUALITY_EVALUATION_CALCULATE.SUCCESS:
      return {
        ...state,
        lists_calculate: action.payload.lists,
        check_calculate: false,
      }
    case LAB_QUALITY_EVALUATION_LOAD_DIVISION.REQUEST:
      return {
        ...state,
        division_list: [],
        check_division_list: true,
      }
    case LAB_QUALITY_EVALUATION_LOAD_DIVISION.SUCCESS:
      return {
        ...state,
        division_list: action.payload.lists,
        check_division_list: false,
      }
    case LAB_QUALITY_EVALUATION_LOAD_DEPARTMENT.REQUEST:
      return {
        ...state,
        department_list: [],
        check_department_list: true,
      }
    case LAB_QUALITY_EVALUATION_LOAD_DEPARTMENT.SUCCESS:
      return {
        ...state,
        department_list: action.payload.lists,
        check_department_list: false,
      }
    case LAB_QUALITY_EVALUATION_LOAD_SECTION.REQUEST:
      return {
        ...state,
        section_list: [],
        check_section_list: true,
      }
    case LAB_QUALITY_EVALUATION_LOAD_SECTION.SUCCESS:
      return {
        ...state,
        section_list: action.payload.lists,
        check_section_list: false,
      }
    case LAB_QUALITY_EVALUATION_LOAD_PLANT.REQUEST:
      return {
        ...state,
        plant_list: [],
        check_plant_list: true,
      }
    case LAB_QUALITY_EVALUATION_LOAD_PLANT.SUCCESS:
      return {
        ...state,
        plant_list: action.payload.lists,
        check_plant_list: false,
      }

    case LAB_QUALITY_EVALUATION_LOAD_LOCATION_FORM.REQUEST:
      return {
        ...state,
        form_location_list: [],
        check_load_location_form: true,
      }
    case LAB_QUALITY_EVALUATION_LOAD_LOCATION_FORM.SUCCESS:
      return {
        ...state,
        form_location_list: action.payload.lists,
        check_load_location_form: false,
      }

    case LAB_QUALITY_EVALUATION_TEST_CENTER.REQUEST:
      return {
        ...state,
        test_center_list: [],
        check_test_center_list: true,
      }
    case LAB_QUALITY_EVALUATION_TEST_CENTER.SUCCESS:
      return {
        ...state,
        test_center_list: action.payload.lists || [],
        check_test_center_list: false,
      }
    case LAB_QUALITY_EVALUATION_EDIT.REQUEST:
      return {
        ...state,
        check_edit: true,
        edit_response: null,
      }
    case LAB_QUALITY_EVALUATION_EDIT.SUCCESS:
      return {
        ...state,
        check_edit: false,
        edit_response: action.payload.lists,
      }

    case LAB_QUALITY_EVALUATION_EXPORT_EXCEL.REQUEST:
      return {
        ...state,
        lab_quality_export_excel: {},
        check_lab_quality_export_excel: true,
      }
    case LAB_QUALITY_EVALUATION_EXPORT_EXCEL.SUCCESS:
      return {
        ...state,
        lab_quality_export_excel: action.payload.lists || {},
        check_lab_quality_export_excel: false,
      }

    case LAB_QUALITY_EVALUATION_GET_USER_CAN_ADD.REQUEST:
      return {
        ...state,
        user_can_add: [],
        check_user_can_add: true,
      }
    case LAB_QUALITY_EVALUATION_GET_USER_CAN_ADD.SUCCESS:
      return {
        ...state,
        user_can_add: action.payload.lists || [],
        check_user_can_add: false,
      }

    default:
      return state
  }
}
